module.exports = __webpack_public_path__ + "img/haiwen_logo.6f098aaa.png";